/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';

import { ReactComponent as ArrowForwardIcon } from '../../assets/images/arrow_forward_ios_24px.svg';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import IconButton from '@material-ui/core/IconButton';
import TableContainer from '@material-ui/core/TableContainer';

const useStyles = makeStyles((theme) => ({
    breadcrumbSection: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.detailsGrey,
        overflow: 'hidden',
    },
    parentTitle: {
        fontWeight: theme.typography.titleFontWeight,
        fontSize: theme.typography.titleFontSize,
        lineHeight: '20px',
        color: theme.palette.text.detailsGrey,
        '@media (max-width:960px)': {
            fontSize: '1.0625rem',
        },
        '@media (max-width:600px)': {
            fontSize: '0.75rem',
            lineHeight: '16px',
            paddingTop: '5px',
        },
    },
    parent: {
        '@media (max-width:500px)': {
            display: 'none',
        },
    },
    parentLink: {
        color: '#086B9C',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '0.8125rem',
        lineHeight: '16px',
        textDecorationLine: 'underline',
    },
    title: {
        color: '#086B9C',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '0.8125rem',
        lineHeight: '16px',
        textDecorationLine: 'underline',
        paddingTop: '5px',
    },
    arrowForward: {
        padding: '0px 4px',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '0.8125rem',
        lineHeight: '16px',
        color: '#5D5D5D',
        marginTop: '7px',
        '@media (max-width:600px)': {
            padding: '0px 5px',
            margin: '6px 0px 0px',
        },
    },
    details: {
        marginTop: '10px',
        marginBottom: '16px',
        color: theme.palette.text.detailsGrey,
        fontSize: '0.875rem',
    },
    iconBtn: {
        padding: '0px',
        paddingTop: '5px',
        color: '#086B9C',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '0.875rem',
        lineHeight: '16px',
        textDecorationLine: 'underline',
    },
    showAllStyle: {
        whiteSpace: 'nowrap',
        padding: '10px 0px',
    },
    breadcrumbOl: {
        padding: 0,
        margin: 0,
        display: 'contents',
        listStyle: 'none',
    },
    ellipsisTitle: {
        '@media (max-width:500px)': {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        },
    },
    noBreakLine: {
        '@media (max-width:500px)': {
            whiteSpace: 'nowrap',
        },
    },
}));

const PageTitleBreadcrumb = ({ parentTitle, parentLink, title, details, subTitle, subLink, thirdLevelTitle }) => {
    const classes = useStyles();
    const isTablet = useMediaQuery('(max-width:960px)');
    const [breadcrumbsHidden, setBreadcrumbsHidden] = useState(false);

    useEffect(() => {
        setBreadcrumbsHidden(isTablet);
    }, [isTablet]);

    return (
        <>
            <TableContainer>
                <nav
                    aria-label="Breadcrumb"
                    className={!breadcrumbsHidden ? [classes.breadcrumbSection, classes.showAllStyle].join(' ') : classes.breadcrumbSection}>
                    <ol className={classes.breadcrumbOl}>
                        <li className={`${classes.parentTitle} ${classes.parent}`}>
                            {parentLink ? (
                                <Link to={'/online-services/trademark'} className={classes.parentLink}>
                                    {parentTitle}
                                </Link>
                            ) : (
                                parentTitle
                            )}
                        </li>
                        <span className={`${classes.arrowForward} ${classes.parent}`} aria-hidden="true">
                            /
                        </span>
                        {!subTitle && <li className={classes.title}>{title}</li>}
                        {subTitle && !thirdLevelTitle && (
                            <li className={classes.parentTitle}>
                                <Link to={subLink} className={`${classes.parentLink} ${classes.noBreakLine}`}>
                                    {title}
                                </Link>
                            </li>
                        )}
                        {subTitle && thirdLevelTitle && (
                            <li className={classes.parentTitle}>
                                <Link to={parentLink} className={`${classes.parentLink} ${classes.noBreakLine}`}>
                                    {title}
                                </Link>
                            </li>
                        )}
                        {!!subTitle && (
                            <span className={classes.arrowForward} aria-hidden="true">
                                /
                            </span>
                        )}
                        {!!subTitle && !!thirdLevelTitle && (
                            <li className={classes.title}>
                                {thirdLevelTitle && (
                                    <Link to={subLink} className={`${classes.parentLink} ${classes.noBreakLine}`}>
                                        {subTitle}
                                    </Link>
                                )}
                            </li>
                        )}
                        {!!subTitle && !thirdLevelTitle && (
                            <li
                                className={`${classes.title} ${classes.ellipsisTitle}`}
                                aria-current="page"
                                style={{ color: '#5D5D5D', textDecoration: 'none' }}>
                                {subTitle}
                            </li>
                        )}
                        {!!thirdLevelTitle && <span className={classes.arrowForward}>/</span>}
                        {!!thirdLevelTitle && (
                            <li
                                className={`${classes.title} ${classes.ellipsisTitle}`}
                                aria-current="page"
                                style={{ color: '#5D5D5D', textDecoration: 'none' }}>
                                {thirdLevelTitle}
                            </li>
                        )}
                    </ol>
                </nav>
            </TableContainer>
            {!!details && (
                <Typography variant="body2" className={classes.details}>
                    {details}
                </Typography>
            )}
        </>
    );
};

export default PageTitleBreadcrumb;
